<button class="btn btn-default paymentbutton" (click)="doTogglePaymentProvider()">
    <h3 class="paymentprovider">
      @if (isOpen()) {
        <svg 
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-chevron-left"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M11.354 1.646a.5.5 0 0 1 0 .708L5.707 8l5.647 5.646a.5.5 0 0 1-.708.708l-6-6a.5.5 0 0 1 0-.708l6-6a.5.5 0 0 1 .708 0"
          />
        </svg>
      }
      @if (channel()?.hide_paymentprovider_logos ?? 0 * 1 === 1) {
        <span>{{paymentprovider().name}}</span>
      } 
      @else {
        <img [src]="paymentprovider().imgsrc" class="logopay" style="height: {{ paymentprovider().imgheight }}px"/>
      }
      @if (!isOpen()) {
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          fill="currentColor"
          class="bi bi-chevron-right"
          viewBox="0 0 16 16"
        >
          <path
            fill-rule="evenodd"
            d="M4.646 1.646a.5.5 0 0 1 .708 0l6 6a.5.5 0 0 1 0 .708l-6 6a.5.5 0 0 1-.708-.708L10.293 8 4.646 2.354a.5.5 0 0 1 0-.708"
          />
        </svg>
      }
    </h3>
  </button>